import { render, staticRenderFns } from "./AbkAdditionalSectionsForm.vue?vue&type=template&id=f42f1da4&scoped=true&"
import script from "./AbkAdditionalSectionsForm.vue?vue&type=script&lang=js&"
export * from "./AbkAdditionalSectionsForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkAdditionalSectionsForm.vue?vue&type=style&index=0&id=f42f1da4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42f1da4",
  null
  
)

export default component.exports